import { makeStyles } from '@material-ui/core/styles';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(theme => ({
  icon: {
    display: 'inline-block',
    height: '8.07vh',
    width: '8.07vh',
    marginTop: '13.86vh',
    marginBottom: '2em',
    color: theme.palette.primary.main,
  },
  iconError: {
    display: 'inline-block',
    height: '8.07vh',
    width: '8.07vh',
    marginTop: '13.86vh',
    marginBottom: '2em',
    color: themeColor.alert,
  },
  iconInfo: {
    display: 'inline-block',
    height: '8.07vh',
    width: '8.07vh',
    marginTop: '13.86vh',
    marginBottom: '2em',
    color: theme.palette.secondary.main,
  },
  iconWarning: {
    display: 'inline-block',
    height: '8.07vh',
    width: '8.07vh',
    marginTop: '13.86vh',
    marginBottom: '2em',
    color: theme.palette.primary.main,
  },
  title: {
    display: 'inline-block',
    fontWeight: 500,
    fontStretch: 'normal',
    lineHeight: '1.17',
    letterSpacing: 0.43,
    fontSize: vh(3.12),
    marginBlockStart: 0,
    marginBlockEnd: '.5em',
    color: theme.palette.primary.main,
  },
  message: {
    lineHeight: '1.56',
    letterSpacing: '0.56px',
    color: themeColor.blackish,
    fontSize: vh(2.34),
    fontWeight: 500,
    marginLeft: '1.09vw',
    marginRight: '1.09vw',
  },
}));
